<form
  #formGroupDirective
  *ngIf="mainFormGroupSubject | async"
  [formGroup]="mainFormGroupSubject | async"
  (ngSubmit)="formSubmitted()"
>
    
    <div gridContainer [colCount]="colCountSubject | async" [spacing]="spacingSubject | async">
      <div  gridItem 
            [colSpan]="getColSpanObs(control) | async" 
            *ngFor="let control of controlsSubject | async" 
            [ngSwitch]="control.type"
        >
        <ss-text-form-control
        
          *ngSwitchCase="'phone'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-text-form-control>
  
        <ss-password-form-control
          *ngSwitchCase="'password'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-password-form-control>
  
        <ss-text-form-control
          *ngSwitchCase="'text'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-text-form-control>
  
        <ss-email-form-control
          *ngSwitchCase="'email'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-email-form-control>
  
        <ss-select-form-control
          *ngSwitchCase="'select'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-select-form-control>
  
        <ss-select-form-control
          *ngSwitchCase="'autocomplete'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-select-form-control>
  
        <ss-date-form-control
          *ngSwitchCase="'date'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-date-form-control>
  
        <ss-slider-form-control
          *ngSwitchCase="'slider'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-slider-form-control>
  
        <ss-text-area-form-control
          *ngSwitchCase="'textarea'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        >
        </ss-text-area-form-control>
  
        <ss-checkbox-form-control
          *ngSwitchCase="'checkbox'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-checkbox-form-control>
  
        <ss-core-checklist-form-control
          *ngSwitchCase="'checklist'"
          class="form-control"
          [dataField]="control.dataField"
          [formControlName]="control.dataField"
        ></ss-core-checklist-form-control>
        
      </div>
    </div>

    <div class="footer">
      <ng-content></ng-content>
    </div>
    <button *ngIf="submitButtonSubject | async" class="display-none"></button>

</form>


